import React from 'react';
import { useSelector } from 'react-redux';
import {
  Redirect,
  Route as RouteDOM,
  type RouteChildrenProps,
  type RouteComponentProps,
} from 'react-router-dom';
import ErrorBoundary from './components/error-boundary/Page';
import { type AppState } from './types/store/states/AppState';

type Route = {
  component: React.ElementType;
  render?: (props: RouteComponentProps) => React.ReactNode;
  children?: ((props: RouteChildrenProps) => React.ReactNode) | React.ReactNode;
  path?: string | string[];
  exact?: boolean;
  sensitive?: boolean;
  strict?: boolean;
};

export const Route = (props: Route) => {
  return (
    <RouteDOM
      path={props.path}
      render={(renderProps) => (
        <ErrorWrapper routeProps={props} renderProps={renderProps} />
      )}
    />
  );
};

export const ProtectedRoute = (props: Route) => {
  const auth = useSelector((state: AppState) => state.auth);

  return (
    <RouteDOM
      path={props.path}
      render={(renderProps) =>
        auth.loggedIn ? (
          <ErrorWrapper routeProps={props} renderProps={renderProps} />
        ) : (
          <Redirect to='/login' />
        )
      }
    />
  );
};

function ErrorWrapper(props: {
  routeProps: Route;
  renderProps: RouteComponentProps;
}) {
  return (
    <ErrorBoundary>
      {React.createElement(props.routeProps.component, props.renderProps)}
    </ErrorBoundary>
  );
}
